
const TEST_TURNSTILE_SITEKEY = "1x00000000000000000000AA";

const getBrowserHost = () => {
  if (typeof window === "undefined") return "";
  return window.location.hostname || "";
};

const isLocalBuild = () => {
  const host = getBrowserHost();
  const productionHosts = ["eethsa.xyz", "eethsaapp.xyz", "eethsacon.xyz"];
  return !productionHosts.includes(host);
};

const getLocalBaseUrl = () => {
  const host = getBrowserHost() || "localhost";
  return `http://${host}:8090/eethsa1`;
};

const LOCAL_BASE_URL = getLocalBaseUrl();

export const CALL_API = isLocalBuild()
  ? `${LOCAL_BASE_URL}/api`
  : process.env.REACT_APP_LINKAPI;

export const CALL_IMAGE = isLocalBuild()
  ? `${LOCAL_BASE_URL}/`
  : process.env.REACT_APP_CALL_IMAGE;

export const CALL_UPLOADS = isLocalBuild()
  ? `${LOCAL_BASE_URL}/Uploads`
  : process.env.REACT_APP_CALL_UPLOADS;

export const SITEKEY = isLocalBuild()
  ? TEST_TURNSTILE_SITEKEY
  : process.env.REACT_APP_SITEKEY;

export const PSITEKEY = isLocalBuild()
  ? TEST_TURNSTILE_SITEKEY
  : process.env.REACT_APP_PSITEKEY;
